import { render, staticRenderFns } from "./Scope.vue?vue&type=template&id=19609450&"
import script from "./Scope.vue?vue&type=script&lang=js&"
export * from "./Scope.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports